// Este archivo será la única fuente de verdad para las monedas soportadas en la aplicación.

export const supportedCurrencies = [
  { code: 'ARS', name: 'Peso Argentino' },
  { code: 'BRL', name: 'Real Brasileño' },
  { code: 'CLP', name: 'Peso Chileno' },
  { code: 'COP', name: 'Peso Colombiano' },
  { code: 'MXN', name: 'Peso Mexicano' },
  { code: 'PEN', name: 'Sol Peruano' },
  { code: 'UYU', name: 'Peso Uruguayo' },
  { code: 'USD', name: 'Dólar Estadounidense' },
];
